import utils from "./utils.js";

const PLAY_SVG = `<svg viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>`;
const LB_EXPAND_SVG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/></svg>`;

// DOM building, observer setup, thumbnail construction, lightbox DOM, placeholder helpers.

const ARROW_SVGS = {
    chevron: {
        prev: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>`,
        next: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>`,
    },
    arrow: {
        prev: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 5 5 12 12 19"/></svg>`,
        next: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>`,
    },
    caret: {
        prev: `<svg viewBox="0 0 24 24"><path d="M14 5L6 12L14 19Z" fill="currentColor" stroke="none"/></svg>`,
        next: `<svg viewBox="0 0 24 24"><path d="M10 5L18 12L10 19Z" fill="currentColor" stroke="none"/></svg>`,
    },
    angle: {
        prev: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 19L8 12L15 5"/></svg>`,
        next: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 19L16 12L9 5"/></svg>`,
    },
    thin: {
        prev: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>`,
        next: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>`,
    },
};

const domMethods = {
    _buildDOM() {
        this.wrapper.classList.add("wcpg-wrapper");
        this.wrapper.classList.remove(
            "wcpg-thumb-bottom",
            "wcpg-thumb-top",
            "wcpg-thumb-left",
            "wcpg-thumb-right",
        );
        this.wrapper.classList.add(`wcpg-thumb-${this.opts.thumbnailPosition}`);
        this.wrapper.setAttribute("data-wcpg-id", this.id);

        const s = this.wrapper.style;
        const thumbAspect = this.opts.thumbnailAspectRatio || "auto";
        s.setProperty("--wcpg-thumb-w", this.opts.thumbnailWidth + "px");
        s.setProperty(
            "--wcpg-thumb-h",
            thumbAspect !== "auto" ? "auto" : this.opts.thumbnailHeight + "px",
        );
        s.setProperty("--wcpg-thumb-aspect", thumbAspect);
        s.setProperty("--wcpg-thumb-gap", this.opts.thumbnailGap + "px");
        s.setProperty("--wcpg-strip-gap", this.opts.thumbnailStripGap + "px");
        s.setProperty(
            "--wcpg-active-color",
            this.opts.thumbnailActiveBorderColor,
        );
        s.setProperty(
            "--wcpg-active-bw",
            this.opts.thumbnailActiveBorderWidth + "px",
        );
        s.setProperty("--wcpg-spinner-color", this.opts.spinnerColor);
        s.setProperty(
            "--wcpg-tr-dur",
            this.opts.mainImageTransitionDuration + "ms",
        );
        s.setProperty("--wcpg-img-bg", this.opts.mainImageBackground);
        s.setProperty("--wcpg-radius", this.opts.mainImageBorderRadius + "px");
        s.setProperty("--wcpg-main-bw", this.opts.mainImageBorderWidth + "px");
        s.setProperty("--wcpg-main-bc", this.opts.mainImageBorderColor);
        s.setProperty(
            "--wcpg-main-shadow",
            this.opts.mainImageShadow ? "0 4px 24px rgba(0,0,0,0.13)" : "none",
        );
        s.setProperty(
            "--wcpg-thumb-radius",
            this.opts.thumbnailBorderRadius + "px",
        );
        s.setProperty(
            "--wcpg-grid-cols",
            String(Math.min(this.opts.thumbnailGridColumns, this.items.length)),
        );
        s.setProperty(
            "--wcpg-arrow-size",
            (this.opts.mainImageArrowSize || 40) + "px",
        );
        s.setProperty(
            "--wcpg-arrow-radius",
            (this.opts.mainImageArrowBorderRadius ?? 50) + "%",
        );
        s.setProperty(
            "--wcpg-arrow-icon-size",
            (this.opts.mainImageArrowIconSize || 18) + "px",
        );
        s.setProperty(
            "--wcpg-arrow-bg",
            this.opts.mainImageArrowBg || "rgba(255,255,255,0.92)",
        );
        s.setProperty(
            "--wcpg-arrow-color",
            this.opts.mainImageArrowColor || "#1a1a1a",
        );
        s.setProperty(
            "--wcpg-arrow-hover-bg",
            this.opts.mainImageArrowHoverBg || "rgba(0,0,0,0.82)",
        );
        s.setProperty(
            "--wcpg-arrow-hover-color",
            this.opts.mainImageArrowHoverColor || "#ffffff",
        );
        s.setProperty(
            "--wcpg-dot-size",
            (this.opts.mainImageDotSize || 5) + "px",
        );
        s.setProperty(
            "--wcpg-dot-color",
            this.opts.mainImageDotColor || "rgba(0,0,0,0.2)",
        );
        s.setProperty(
            "--wcpg-dot-active-color",
            this.opts.mainImageDotActiveColor || "rgba(0,0,0,0.82)",
        );
        s.setProperty("--wcpg-stacked-gap", this.opts.stackedItemGap + "px");
        s.setProperty("--wcpg-stacked-dot-gap", this.opts.stackedDotGap + "px");
        s.setProperty(
            "--wcpg-stacked-dot-size",
            this.opts.stackedDotSize + "px",
        );
        s.setProperty("--wcpg-stacked-dot-color", this.opts.stackedDotColor);
        s.setProperty(
            "--wcpg-stacked-dot-active-color",
            this.opts.stackedDotActiveColor,
        );
        s.setProperty(
            "--wcpg-hg-cols",
            String(this.opts.hierarchyGridColumns || 2),
        );
        s.setProperty(
            "--wcpg-hg-gap",
            (this.opts.hierarchyGridGap ?? 16) + "px",
        );
        s.setProperty(
            "--wcpg-hg-item-radius",
            (this.opts.hierarchyGridItemBorderRadius ?? 6) + "px",
        );
        s.setProperty(
            "--wcpg-hg-item-aspect",
            this.opts.hierarchyGridItemAspect === "auto"
                ? "auto"
                : this.opts.hierarchyGridItemAspect,
        );
        s.setProperty(
            "--wcpg-hg-item-fit",
            this.opts.hierarchyGridItemFit || "cover",
        );

        s.setProperty("--wcpg-tiles-cols", String(this.opts.tilesColumns || 2));
        s.setProperty("--wcpg-tiles-gap", (this.opts.tilesGap ?? 8) + "px");
        s.setProperty(
            "--wcpg-tiles-item-radius",
            (this.opts.tilesItemBorderRadius ?? 0) + "px",
        );
        s.setProperty(
            "--wcpg-tiles-item-aspect",
            this.opts.tilesItemAspect === "auto"
                ? "auto"
                : this.opts.tilesItemAspect || "3/2",
        );
        s.setProperty(
            "--wcpg-tiles-item-fit",
            this.opts.tilesItemFit || "cover",
        );

        // Clean up old injected elements (reinit)
        [
            "wcpg-stage",
            "wcpg-thumbnails-wrap",
            "wcpg-row",
            "wcpg-ss-row",
            "wcpg-hg-wrap",
            "wcpg-tiles-wrap",
        ].forEach((cls) => {
            this.wrapper.querySelectorAll("." + cls).forEach((n) => n.remove());
        });

        // ── Stacked layout (Anchor Dots mode) — branch early ──
        if (this.opts.galleryType === "anchor" && !this._mobileLayoutActive) {
            this._buildStackedLayout();
            return;
        }

        // ── Sticky Split layout — branch early (unless mobile fallback active) ──
        if (
            this.opts.galleryType === "sticky-split" &&
            !this._mobileLayoutActive
        ) {
            this._buildStickySplitLayout();
            return;
        }

        // ── Hierarchy Grid layout — branch early ──
        if (
            this.opts.galleryType === "hierarchy-grid" &&
            !this._mobileLayoutActive
        ) {
            this._buildHierarchyGridLayout();
            return;
        }

        // ── Tiles layout — branch early ──
        if (this.opts.galleryType === "tiles" && !this._mobileLayoutActive) {
            this._buildTilesLayout();
            return;
        }

        // ── Stage ──
        this.stage = utils.el("div", "wcpg-stage");
        this.mainWrap = utils.el("div", "wcpg-main-wrap");

        // Main display wrapper (image + video inside)
        this.mainDisplay = utils.el("div", "wcpg-main-display");
        if (
            this.opts.mainImageHeightMode === "fixed" &&
            this.opts.mainImageHeight
        )
            this.mainDisplay.style.height = this.opts.mainImageHeight + "px";

        this.mainImg = utils.el("img", "wcpg-main-img");
        this.mainImg.draggable = false;
        this.mainImg.style.objectFit = this.opts.mainImageFit;
        // Don't add wcpg-fit-cover on mobile — the absolute-fill technique requires
        // the container to have a known height, which mobile doesn't guarantee.
        if (this.opts.mainImageFit === "cover" && !this._mobileLayoutActive) {
            this.mainDisplay.classList.add("wcpg-fit-cover");
        }

        // Blur-up placeholder: a tiny image shown immediately while the full
        // image loads. Sits behind mainImg (lower z-index). JS fades it out
        // once mainImg has finished loading.
        this.placeholderImg = utils.el("img", "wcpg-placeholder-img");
        this.placeholderImg.draggable = false;
        this.placeholderImg.alt = "";
        this.placeholderImg.setAttribute("aria-hidden", "true");

        this.mainVideo = utils.el("video", "wcpg-main-video");
        this.mainVideo.controls = this.opts.videoControls;
        this.mainVideo.playsInline = true;
        this.mainVideo.loop = this.opts.videoHostedLoop;
        if (this.opts.videoHostedMuted) this.mainVideo.muted = true;
        this.mainVideo.style.display = "none";

        // Iframe for YouTube / Vimeo embeds. src is set/cleared on navigation —
        // setting src="" stops playback without removing the element from the DOM.
        this.mainIframe = utils.el("iframe", "wcpg-main-iframe");
        this.mainIframe.setAttribute("frameborder", "0");
        this.mainIframe.setAttribute("allowfullscreen", "");
        this.mainIframe.setAttribute(
            "referrerpolicy",
            "strict-origin-when-cross-origin",
        );
        this.mainIframe.setAttribute(
            "allow",
            "autoplay; fullscreen; picture-in-picture; encrypted-media",
        );
        this.mainIframe.setAttribute("title", "");
        this.mainIframe.style.display = "none";

        this.mainDisplay.appendChild(this.placeholderImg);
        this.mainDisplay.appendChild(this.mainImg);
        this.mainDisplay.appendChild(this.mainVideo);
        this.mainDisplay.appendChild(this.mainIframe);

        // ── Linked-video play button ──────────────────────────────────────
        // Overlaid on the main image when the current gallery item has an
        // attached video. Clicking it plays the video in the main area.
        this._linkedVideoBtn = utils.el("button", "wcpg-linked-video-btn");
        this._linkedVideoBtn.setAttribute("aria-label", "Play video");
        this._linkedVideoBtn.innerHTML = PLAY_SVG;
        this._linkedVideoBtn.style.display = "none";
        utils.on(this._linkedVideoBtn, "click", (e) => {
            e.stopPropagation(); // don't trigger lightbox
            this._playLinkedVideo();
        });
        this.mainDisplay.appendChild(this._linkedVideoBtn);

        // Spinner
        this.spinner = utils.el("div", "wcpg-spinner");
        this.spinner.appendChild(utils.el("div", "wcpg-spinner-inner"));

        // ── Lens / Window Cursor / Zoom Window ──
        ({ lens: this.lens, winCursor: this.winCursor, zoomWin: this.zoomWin } =
            this._buildZoomElements());
        this.mainWrap.appendChild(this.winCursor);

        // Lightbox trigger
        this.lbTrigger = null;
        if (this.opts.lightbox && this.opts.lightboxOnClick) {
            this.lbTrigger = this._makeLbTriggerBtn();
            this.mainWrap.appendChild(this.lbTrigger);
            if (!this.opts.lightboxButtonAutoHide) {
                this.mainWrap.classList.add("wcpg-lb-always");
            }
        }

        // ── Main image navigation arrows ──
        // When in mobile fallback, arrows/pagination use the mobile-specific
        // settings so desktop behaviour is completely unaffected.
        const _mbl = !!this._mobileLayoutActive;
        const _effArrows = _mbl
            ? this.opts.mobileArrows !== false
            : !!this.opts.mainImageArrows;
        const _effPagination = _mbl
            ? this.opts.mobilePagination !== false
            : !!this.opts.mainImagePagination;
        const _effPgPos = _mbl
            ? this.opts.mobilePaginationPosition || "bottom"
            : this.opts.mainImagePaginationPosition || "bottom";
        const _effPgType = _mbl
            ? "dots"
            : this.opts.mainImagePaginationType || "dots";
        const _effPgAutoHide = _mbl
            ? false
            : !!this.opts.mainImagePaginationAutoHide;

        this.mainPrev = null;
        this.mainNext = null;
        if (_effArrows && this.items.length > 1) {
            this.mainPrev = utils.el(
                "button",
                "wcpg-main-arrow wcpg-main-prev",
            );
            this.mainPrev.setAttribute("aria-label", "Previous image");
            const _arrowSvg =
                ARROW_SVGS[this.opts.mainImageArrowIcon] || ARROW_SVGS.chevron;
            this.mainPrev.innerHTML = _arrowSvg.prev;
            this.mainNext = utils.el(
                "button",
                "wcpg-main-arrow wcpg-main-next",
            );
            this.mainNext.setAttribute("aria-label", "Next image");
            this.mainNext.innerHTML = _arrowSvg.next;
            this.mainWrap.appendChild(this.mainPrev);
            this.mainWrap.appendChild(this.mainNext);
            if (!_mbl && !this.opts.mainImageArrowsAutoHide) {
                this.mainWrap.classList.add("wcpg-arrows-always");
            }
        }

        this.mainWrap.appendChild(this.mainDisplay);
        this.mainWrap.appendChild(this.spinner);
        this.mainWrap.appendChild(this.lens);
        this.stage.appendChild(this.mainWrap);

        // ── Main image pagination (dots or progress bar) ──
        this.pagination = null;
        this.paginationDots = [];
        this.progressFill = null;
        this._countText = null;
        if (_effPagination && this.items.length > 1) {
            this.pagination = utils.el("div", "wcpg-pagination");

            if (_effPgPos === "left" || _effPgPos === "right") {
                this.pagination.classList.add(
                    "wcpg-pagination-side",
                    `wcpg-pagination-${_effPgPos}`,
                );
            } else if (_effPgPos === "top") {
                this.pagination.classList.add("wcpg-pagination-top");
            }

            if (_effPgType === "progressbar") {
                this.pagination.classList.add("wcpg-pagination-progress");
                this.progressFill = utils.el("div", "wcpg-progress-fill");
                this.progressFill.style.width =
                    (1 / this.items.length) * 100 + "%";
                this.pagination.appendChild(this.progressFill);
            } else if (_effPgType === "count") {
                this.pagination.classList.add("wcpg-pagination-count");
                const countPrev = utils.el(
                    "button",
                    "wcpg-count-nav wcpg-count-prev",
                );
                countPrev.setAttribute("aria-label", "Previous image");
                countPrev.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>`;
                this._countText = utils.el("span", "wcpg-count-text");
                this._countText.textContent = `1 / ${this.items.length}`;
                const countNext = utils.el(
                    "button",
                    "wcpg-count-nav wcpg-count-next",
                );
                countNext.setAttribute("aria-label", "Next image");
                countNext.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>`;
                this.pagination.appendChild(countPrev);
                this.pagination.appendChild(this._countText);
                this.pagination.appendChild(countNext);
            } else {
                this.items.forEach((_, i) => {
                    const dot = utils.el(
                        "button",
                        "wcpg-dot" + (i === 0 ? " wcpg-dot-active" : ""),
                    );
                    dot.setAttribute("aria-label", `Go to image ${i + 1}`);
                    dot.setAttribute("data-index", i);
                    this.pagination.appendChild(dot);
                    this.paginationDots.push(dot);
                });
            }

            // Anchor layout places dots inside .wcpg-stage so they aren't clipped
            // by mainWrap's overflow:hidden. In mobile fallback the carousel layout
            // is used regardless of galleryType, so always append to mainWrap there.
            if (this.opts.galleryType === "anchor" && !_mbl) {
                this.pagination.classList.add("wcpg-pagination-anchor");
                this.stage.appendChild(this.pagination);
            } else {
                if (_effPgAutoHide) {
                    this.pagination.classList.add("wcpg-pagination-autohide");
                }
                this.mainWrap.appendChild(this.pagination);
            }
        }

        // Append to body (not stage) so the zoom window is never clipped by
        // any ancestor's overflow:hidden (e.g. the WooCommerce gallery wrapper).
        // CSS uses position:fixed so coordinates map directly to the viewport.
        document.body.appendChild(this.zoomWin);

        // ── Thumbnails ──
        this.thumbsWrap = null;
        // When falling back from anchor/sticky-split to carousel, mobileShowThumbs
        // controls visibility independently of the main thumbnailShow setting.
        const _showThumbs = this._mobileLayoutActive
            ? !!this.opts.mobileShowThumbs
            : this.opts.thumbnailShow !== false;
        if (this.items.length > 1 && _showThumbs) this._buildThumbnails();

        // On mobile, force a slider (never grid) but honour mobileThumbnailPosition
        // for the wrapper class and layout so the strip can appear on any side.
        const _mblSlider = !!this._mobileLayoutActive;
        const _effThumbPos = this._mobileLayoutActive
            ? this.opts.mobileThumbnailPosition || "bottom"
            : this.opts.thumbnailPosition;
        if (_mblSlider && this.thumbsWrap) {
            this.wrapper.classList.remove(
                "wcpg-thumb-left",
                "wcpg-thumb-right",
                "wcpg-thumb-top",
                "wcpg-thumb-bottom",
            );
            this.wrapper.classList.add(`wcpg-thumb-${_effThumbPos}`);
        }

        // Override thumbnail CSS variables with mobile-specific sizes so both the
        // visual rendering and the JS scroll calculations use the same dimensions.
        if (this._mobileLayoutActive && this.thumbsWrap) {
            const mW = this.opts.mobileThumbnailWidth;
            const mH = this.opts.mobileThumbnailHeight;
            if (mW > 0) s.setProperty("--wcpg-thumb-w", mW + "px");
            if (mH > 0) s.setProperty("--wcpg-thumb-h", mH + "px");
        }

        // ── Lightbox ──
        if (this.opts.lightbox && !this.constructor._lbEl) {
            this.constructor._lbEl = this._createLightboxDOM();
            document.body.appendChild(this.constructor._lbEl);
        }

        // ── Layout ──
        const isHoriz = ["left", "right"].includes(_effThumbPos);
        if (isHoriz && this.thumbsWrap) {
            const row = utils.el("div", "wcpg-row");
            if (_effThumbPos === "left") {
                row.appendChild(this.thumbsWrap);
                row.appendChild(this.stage);
            } else {
                row.appendChild(this.stage);
                row.appendChild(this.thumbsWrap);
            }
            this.wrapper.appendChild(row);
        } else {
            // For both 'top' and 'bottom', stage comes first in the DOM.
            // CSS uses flex-direction:column-reverse on .wcpg-thumb-top to
            // visually promote the thumbnails above the stage — so we must
            // NOT manually reorder the DOM here or the two effects cancel.
            this.wrapper.appendChild(this.stage);
            if (this.thumbsWrap) this.wrapper.appendChild(this.thumbsWrap);
        }

        // Set initial item
        this._renderItem(0, true);

        // Gallery is built and first image is rendering — remove the server-side
        // loading skeleton. Done here (not in _renderItem) so it only fires once,
        // after both the DOM and the blur-up placeholder are in place.
        this._removeSkeleton();

        this._setupFitObserver();
        this._initStackObserver();
    },

    _setupFitObserver() {
        if (this._fitObserver) {
            this._fitObserver.disconnect();
            this._fitObserver = null;
        }
        if (!this.thumbsWrap || !this.stage) return;

        // Grid layout is never active on mobile (mobile forces slider).
        const isGrid =
            !this._mobileLayoutActive && this.opts.thumbnailLayout === "grid";
        // On mobile, use mobileThumbnailPosition to determine side positioning.
        const isSidePos = this._mobileLayoutActive
            ? ["left", "right"].includes(
                  this.opts.mobileThumbnailPosition || "bottom",
              )
            : ["left", "right"].includes(this.opts.thumbnailPosition);

        // Grid layout: only runs when thumbnailFitToImage is on
        if (isGrid) {
            if (!this.opts.thumbnailFitToImage) return;
            const syncGrid = () => {
                const cols = this.opts.thumbnailGridColumns;
                const gap = this.opts.thumbnailGap;
                const stacked = this.wrapper.classList.contains("wcpg-stacked");
                // Treat as vertical only when truly side-positioned and NOT stacked
                const fitVert = isSidePos && !stacked;

                if (fitVert) {
                    // Left/right grid: always 1 column, items stack vertically.
                    // Distribute stage height evenly across all rows.
                    this.thumbsWrap.classList.remove("wcpg-grid-fit");
                    const rows = this.items.length; // 1 column → each item is its own row
                    const totalH = this.stage.offsetHeight;
                    if (totalH > 0 && rows > 0) {
                        const size = (totalH - gap * (rows - 1)) / rows;
                        if (size > 0) {
                            this.wrapper.style.setProperty(
                                "--wcpg-thumb-h",
                                size + "px",
                            );
                        }
                    }
                } else {
                    // Bottom/top (or stacked left/right): use 1fr columns so the grid
                    // fills stage width pixel-perfectly without rounding gaps.
                    this.thumbsWrap.classList.add("wcpg-grid-fit");
                    this.thumbsWrap.style.width = ""; // let CSS give 100%
                    const totalW = this.stage.offsetWidth;
                    if (totalW > 0 && cols > 0) {
                        const size = (totalW - gap * (cols - 1)) / cols;
                        if (size > 0) {
                            this.wrapper.style.setProperty(
                                "--wcpg-thumb-h",
                                size + "px",
                            );
                        }
                    }
                }
            };
            this._fitObserver = new ResizeObserver(syncGrid);
            this._fitObserver.observe(this.stage);
            if (this.mainImg) this._fitObserver.observe(this.mainImg);
            syncGrid();
            return;
        }

        // Slider: left/right only — match thumbsWrap height to stage height
        if (!isSidePos || !this.opts.thumbnailFitToImage) return;
        const sync = () => {
            const h = this.stage.offsetHeight;
            if (h > 0) {
                this.thumbsWrap.style.height = h + "px";
                this._clampThumbOffset();
            }
        };
        this._fitObserver = new ResizeObserver(sync);
        this._fitObserver.observe(this.stage);
        if (this.mainImg) this._fitObserver.observe(this.mainImg);
        sync();
    },

    _initStackObserver() {
        // Clean up any previous listener
        if (this._stackMq && this._stackMqFn) {
            this._stackMq.removeEventListener("change", this._stackMqFn);
        }
        this._stackMq = null;
        this._stackMqFn = null;
        this.wrapper.classList.remove("wcpg-stacked");

        const bp = this.opts.thumbnailBreakpoint;
        if (
            !bp ||
            bp <= 0 ||
            !["left", "right"].includes(this.opts.thumbnailPosition) ||
            this._mobileLayoutActive // mobile uses its own position; never stack
        )
            return;

        // Use viewport-based matchMedia so the breakpoint behaves like a
        // standard CSS media query — matching device/screen width, not the
        // gallery container width (which is always narrower on product pages).
        this._stackMq = window.matchMedia(`(max-width: ${bp - 1}px)`);
        this._stackMqFn = (e) => {
            this.wrapper.classList.toggle("wcpg-stacked", e.matches);
            // For left/right grid: clear any inline width so CSS takes over,
            // then re-run the fit observer for the new axis.
            if (this.opts.thumbnailLayout === "grid" && this.thumbsWrap) {
                this.thumbsWrap.style.width = "";
                if (this._fitObserver) {
                    this._fitObserver.disconnect();
                    this._fitObserver = null;
                }
                this._setupFitObserver();
            }
            // Reset scroll position — the old axis offset is meaningless after flip
            if (this._ts) this._ts.offset = 0;
            this._clampThumbOffset();
        };
        this._stackMq.addEventListener("change", this._stackMqFn);
        // Apply the initial state immediately
        this.wrapper.classList.toggle("wcpg-stacked", this._stackMq.matches);
    },

    _buildThumbnails() {
        // On mobile, always force a slider (never grid); position comes from mobileThumbnailPosition.
        const _mblSlider = !!this._mobileLayoutActive;
        const isGrid = !_mblSlider && this.opts.thumbnailLayout === "grid";
        const _mblPos = this._mobileLayoutActive
            ? this.opts.mobileThumbnailPosition || "bottom"
            : null;
        const isVert = _mblSlider
            ? ["left", "right"].includes(_mblPos)
            : ["left", "right"].includes(this.opts.thumbnailPosition);

        this.thumbsWrap = utils.el(
            "div",
            `wcpg-thumbnails-wrap wcpg-thumbs-${isGrid ? "grid" : "slider"}`,
        );

        if (isVert && this.opts.thumbnailFitToImage) {
            this.thumbsWrap.classList.add("wcpg-slider-fit");
        }

        if (!isGrid && this.opts.thumbnailArrowsOverlay) {
            this.thumbsWrap.classList.add("wcpg-arrows-overlay");
        }

        this.thumbsWrap.classList.add(
            `wcpg-align-${this.opts.thumbnailAlignment || "left"}`,
        );

        if (this.opts.thumbnailAnimation) {
            this.thumbsWrap.classList.add("wcpg-thumbs-animate");
        }

        if (!isGrid) {
            // Slider layout
            if (this.opts.thumbnailSliderButtons) {
                this.thumbPrev = utils.el(
                    "button",
                    "wcpg-thumb-btn wcpg-thumb-prev",
                );
                this.thumbPrev.setAttribute("aria-label", "Previous");
                this.thumbPrev.innerHTML = isVert
                    ? `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="18 15 12 9 6 15"/></svg>`
                    : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>`;
                this.thumbNext = utils.el(
                    "button",
                    "wcpg-thumb-btn wcpg-thumb-next",
                );
                this.thumbNext.setAttribute("aria-label", "Next");
                this.thumbNext.innerHTML = isVert
                    ? `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>`
                    : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>`;
                this.thumbsWrap.appendChild(this.thumbPrev);
            }
            this.thumbsTrack = utils.el("div", "wcpg-thumbnails-track");
            if (isVert) this.thumbsTrack.classList.add("wcpg-track-vert");
            this.thumbsList = utils.el("div", "wcpg-thumbnails-list");
            this._buildThumbItems();
            this.thumbsTrack.appendChild(this.thumbsList);
            this.thumbsWrap.appendChild(this.thumbsTrack);
            if (this.opts.thumbnailSliderButtons)
                this.thumbsWrap.appendChild(this.thumbNext);
        } else {
            // Grid layout
            this.thumbsList = utils.el(
                "div",
                "wcpg-thumbnails-list wcpg-thumbs-grid-list",
            );
            this._buildThumbItems();
            this.thumbsWrap.appendChild(this.thumbsList);
        }

        // Defer until after the wrap is inserted into the live DOM so
        // offsetWidth/offsetHeight return real layout values.
        requestAnimationFrame(() => this._updateThumbButtons());
    },

    _buildThumbItems() {
        this.thumbEls = [];
        this.items.forEach((item, i) => {
            const t = utils.el(
                "div",
                "wcpg-thumb-item" + (i === 0 ? " wcpg-thumb-active" : ""),
            );
            t.setAttribute("role", "option");
            t.setAttribute("aria-selected", i === 0 ? "true" : "false");
            t.setAttribute("tabindex", "0");
            t.setAttribute("data-index", i);

            if (this.opts.thumbnailBackground) {
                t.style.backgroundColor = this.opts.thumbnailBackground;
            }

            const isMediaItem = item.type !== "image";
            if (!isMediaItem || item.thumb) {
                const tImg = utils.el("img");
                tImg.src = item.thumb || item.src;
                tImg.alt =
                    item.caption ||
                    (isMediaItem ? `Video ${i + 1}` : `Image ${i + 1}`);
                tImg.draggable = false;
                if (this.opts.thumbnailBackground) {
                    tImg.style.mixBlendMode = "darken";
                }
                if (isMediaItem) {
                    // If the thumb URL fails to load, fall back to CSS placeholder
                    tImg.onerror = () => {
                        tImg.remove();
                        t.classList.add("wcpg-thumb-no-thumb");
                    };
                }
                t.appendChild(tImg);
            } else {
                // Media item with no thumbnail — CSS placeholder takes over
                t.classList.add("wcpg-thumb-no-thumb");
            }

            if (isMediaItem) {
                const badge = utils.el("div", "wcpg-thumb-play-badge");
                badge.innerHTML = PLAY_SVG;
                t.appendChild(badge);
                t.classList.add("wcpg-thumb-video");
            }

            // Image items that have a linked video get a play badge too.
            if (!isMediaItem && item.linkedVideoType) {
                const badge = utils.el("div", "wcpg-thumb-play-badge");
                badge.innerHTML = PLAY_SVG;
                t.appendChild(badge);
                t.classList.add("wcpg-thumb-has-video");
            }

            // Staggered entrance animation: each item starts 60 ms after the
            // previous, capped at 480 ms so long strips don't drag on too long.
            if (this.opts.thumbnailAnimation) {
                t.style.setProperty(
                    "--wcpg-thumb-delay",
                    Math.min(i * 60, 480) + "ms",
                );
            }

            this.thumbsList.appendChild(t);
            this.thumbEls.push(t);
        });
    },

    _createLightboxDOM() {
        const lb = utils.el("div", "wcpg-lightbox");
        lb.setAttribute("role", "dialog");
        lb.setAttribute("aria-modal", "true");
        lb.setAttribute("aria-label", "Image viewer");
        lb.innerHTML = `
        <div class="wcpg-lb-overlay"></div>
        <div class="wcpg-lb-container">

          <!-- Top toolbar -->
          <div class="wcpg-lb-toolbar">
            <div class="wcpg-lb-counter-wrap">
              <span class="wcpg-lb-counter"></span>
            </div>

            <!-- Center image transformation tools -->
            <div class="wcpg-lb-image-tools">
              <button class="wcpg-lb-tool wcpg-lb-rotate-ccw" aria-label="Rotate counter-clockwise"
                title="Rotate counter-clockwise">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 2v6h6"/>
                  <path d="M3 13a9 9 0 1 0 3-7.7L3 8"/>
                </svg>
              </button>
              <button class="wcpg-lb-tool wcpg-lb-rotate-cw" aria-label="Rotate clockwise"
                title="Rotate clockwise">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 2v6h-6"/>
                  <path d="M21 13a9 9 0 1 1-3-7.7L21 8"/>
                </svg>
              </button>
              <span class="wcpg-lb-tools-sep"></span>
              <button class="wcpg-lb-tool wcpg-lb-flip-h" aria-label="Flip horizontal"
                title="Flip horizontal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 3v18"/>
                  <path d="M5 7l-3 5 3 5"/>
                  <path d="M19 7l3 5-3 5"/>
                </svg>
              </button>
              <button class="wcpg-lb-tool wcpg-lb-flip-v" aria-label="Flip vertical"
                title="Flip vertical">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 12h18"/>
                  <path d="M8 5l4-3 4 3"/>
                  <path d="M8 19l4 3 4-3"/>
                </svg>
              </button>
              <span class="wcpg-lb-tools-sep"></span>
              <button class="wcpg-lb-tool wcpg-lb-zoom-1to1" aria-label="Toggle 1:1 zoom"
                title="Toggle 1:1 zoom">1:1</button>
            </div>

            <div class="wcpg-lb-tools">
              <button class="wcpg-lb-tool wcpg-lb-zoom-in"  aria-label="Zoom in"
                title="Zoom in">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  <line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>
                </svg>
              </button>
              <button class="wcpg-lb-tool wcpg-lb-zoom-out" aria-label="Zoom out"
                title="Zoom out">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  <line x1="8" y1="11" x2="14" y2="11"/>
                </svg>
              </button>
              <button class="wcpg-lb-tool wcpg-lb-zoom-reset" aria-label="Reset zoom"
                title="Reset zoom" style="display:none">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                  <path d="M3 3v5h5"/>
                </svg>
              </button>
              <button class="wcpg-lb-tool wcpg-lb-autoplay" aria-label="Autoplay"
                title="Start slideshow">
                <svg class="wcpg-play-icon"  viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>
                <svg class="wcpg-pause-icon" viewBox="0 0 24 24" fill="currentColor" style="display:none"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
              </button>
              <button class="wcpg-lb-tool wcpg-lb-fullscreen" aria-label="Fullscreen"
                title="Enter fullscreen">
                <svg class="wcpg-fs-enter" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/>
                </svg>
                <svg class="wcpg-fs-exit" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="display:none">
                  <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 0 2-2h3M3 16h3a2 2 0 0 0 2 2v3"/>
                </svg>
              </button>
              <div class="wcpg-lb-share-wrap" style="display:none">
                <button class="wcpg-lb-tool wcpg-lb-share" aria-label="Share" title="Share">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
                    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
                  </svg>
                </button>
                <div class="wcpg-lb-share-dropdown" style="display:none" role="menu">
                  <button class="wcpg-lb-share-item wcpg-lb-share-fb" role="menuitem">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
                    Share on Facebook
                  </button>
                  <button class="wcpg-lb-share-item wcpg-lb-share-tw" role="menuitem">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                    Tweet
                  </button>
                  <button class="wcpg-lb-share-item wcpg-lb-share-pi" role="menuitem">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg>
                    Pin it
                  </button>
                  <button class="wcpg-lb-share-item wcpg-lb-share-dl" role="menuitem">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                    <span class="wcpg-dl-label">Download image</span>
                  </button>
                </div>
              </div>
              <button class="wcpg-lb-tool wcpg-lb-close" aria-label="Close"
                title="Close (Esc)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Navigation arrows -->
          <button class="wcpg-lb-arrow wcpg-lb-prev" aria-label="Previous image">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>

          <!-- Media area -->
          <div class="wcpg-lb-media-wrap">
            <div class="wcpg-lb-media-inner">
              <img class="wcpg-lb-img" draggable="false" alt="">
              <video class="wcpg-lb-video" controls playsinline
                style="display:none;max-width:90vw;max-height:75vh;border-radius:8px;"></video>
              <iframe class="wcpg-lb-iframe" referrerpolicy="strict-origin-when-cross-origin" frameborder="0" allowfullscreen
                allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
                title="" style="display:none"></iframe>
              <div class="wcpg-lb-spinner">
                <div class="wcpg-spinner-inner wcpg-lb-spin-inner"></div>
              </div>
              <button class="wcpg-lb-linked-video-btn" aria-label="Play video" style="display:none">
                <svg viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>
              </button>
            </div>
          </div>

          <button class="wcpg-lb-arrow wcpg-lb-next" aria-label="Next image">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>

          <!-- Caption -->
          <div class="wcpg-lb-caption-wrap">
            <div class="wcpg-lb-caption"></div>
          </div>

          <!-- Thumbnail strip -->
          <div class="wcpg-lb-thumbs-strip"></div>

        </div>`;
        return lb;
    },

    // Resets inline styles applied by the embed cover (fit-to-container) mode.
    _resetIframeCoverStyles() {
        if (!this.mainIframe) return;
        Object.assign(this.mainIframe.style, {
            position: "",
            top: "",
            left: "",
            width: "",
            height: "",
            transform: "",
            aspectRatio: "",
        });
    },

    _showPlaceholder(item) {
        // Guard: only fire once (initial page load). Once _hidePlaceholder
        // removes the element, this.placeholderImg is nulled permanently.
        const p = this.placeholderImg;
        if (!p || !item.placeholder) return;
        // Only lock mode needs this collapse-prevention aspect-ratio; adaptive
        // mode sets aspect-ratio per-swap in _renderItem() instead.
        if (item.w && item.h && this.opts.mainImageHeightMode === "lock") {
            this.mainDisplay.style.aspectRatio = `${item.w} / ${item.h}`;
        }
        p.src = item.placeholder;
        p.style.objectFit = this.opts.mainImageFit;
        p.classList.add("wcpg-placeholder-active");
    },

    _hidePlaceholder() {
        const p = this.placeholderImg;
        if (!p) return;
        // Null out immediately so no further calls can reactivate it.
        this.placeholderImg = null;
        p.classList.remove("wcpg-placeholder-active");
        // Remove from DOM after the CSS fade finishes — after this point the
        // element is gone and cannot interfere with any transition animations.
        setTimeout(() => {
            p.src = "";
            p.remove();
            // Adaptive mode owns aspect-ratio via _renderItem() — do not clear it here.
            if (this.opts.mainImageHeightMode !== "adaptive") {
                this.mainDisplay.style.aspectRatio = "";
            }
        }, 400);
    },

    _buildSingleStackedItem(item, i) {
        const itemWrap = utils.el("div", "wcpg-stacked-item");
        itemWrap.setAttribute("data-wcpg-stacked-index", i);
        const isVid = item.type === "video";
        const isEmbed = item.type === "youtube" || item.type === "vimeo";
        if (isEmbed) {
            const iframe = utils.el("iframe", "wcpg-stacked-iframe");
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute(
                "allow",
                "autoplay; fullscreen; picture-in-picture; encrypted-media",
            );
            let embedSrc = item.embed || item.src;
            if (
                item.type === "youtube" &&
                embedSrc.indexOf("enablejsapi=") === -1
            ) {
                embedSrc +=
                    (embedSrc.indexOf("?") === -1 ? "?" : "&") +
                    "enablejsapi=1";
            }
            iframe.src = embedSrc;
            itemWrap.appendChild(iframe);
        } else if (isVid) {
            const video = utils.el("video", "wcpg-stacked-video");
            video.controls = this.opts.videoControls;
            video.playsInline = true;
            video.loop = this.opts.videoHostedLoop;
            if (this.opts.videoHostedMuted) video.muted = true;
            video.src = item.src;
            if (item.poster) video.poster = item.poster;
            itemWrap.appendChild(video);
        } else {
            const zoomDisplay = utils.el("div", "wcpg-stacked-display");
            const img = utils.el("img", "wcpg-stacked-img");
            img.src = item.src;
            img.alt = item.caption || "";
            img.draggable = false;
            img.style.objectFit = this.opts.mainImageFit;
            if (item.w && item.h) {
                itemWrap.style.aspectRatio = `${item.w} / ${item.h}`;
            }
            if (item.placeholder) {
                const ph = utils.el("img", "wcpg-stacked-placeholder");
                ph.src = item.placeholder;
                ph.alt = "";
                ph.draggable = false;
                ph.setAttribute("aria-hidden", "true");
                ph.style.objectFit = this.opts.mainImageFit;
                zoomDisplay.appendChild(ph);
                const clearPh = () => {
                    itemWrap.style.aspectRatio = "";
                    ph.classList.add("wcpg-stacked-ph-hide");
                    setTimeout(() => ph.remove(), 400);
                };
                if (img.complete && img.naturalWidth > 0) {
                    ph.remove();
                    itemWrap.style.aspectRatio = "";
                } else {
                    img.addEventListener("load", clearPh, { once: true });
                }
            }
            zoomDisplay.appendChild(img);
            itemWrap.appendChild(zoomDisplay);
            if (item.linkedVideoType) {
                this._buildLinkedVideoOverlay(itemWrap, item);
            }
        }
        if (this.opts.lightbox && this.opts.lightboxOnClick) {
            const btn = this._makeLbTriggerBtn();
            itemWrap.appendChild(btn);
            if (this._stackedLbTriggers) {
                this._stackedLbTriggers.push({ el: btn, index: i });
            }
            if (!this.opts.lightboxButtonAutoHide) {
                itemWrap.classList.add("wcpg-lb-always");
            }
        }
        return itemWrap;
    },

    _buildStackedLayout() {
        // Renders all gallery items as a vertical stack (Anchor Navigation mode).
        // Dots live in an absolute anchor rail; position:sticky keeps them
        // centred in the viewport while the stack is scrolled through.

        this.wrapper.classList.add("wcpg-layout-stacked");

        // Null out carousel-specific refs so _destroy() guards work correctly
        this.mainWrap = null;
        this.mainDisplay = null;
        this.mainImg = null;
        this.mainVideo = null;
        this.mainIframe = null;
        this.placeholderImg = null;
        this.spinner = null; // no spinner in stacked layout

        const _anchorZoomEnabled =
            this.opts.anchorZoom !== false && this.opts.zoomOnHover;

        if (_anchorZoomEnabled) {
            ({ lens: this.lens, winCursor: this.winCursor, zoomWin: this.zoomWin } =
                this._buildZoomElements());
            document.body.appendChild(this.zoomWin);
        } else {
            this.lens = null;
            this.winCursor = null;
            this.zoomWin = null;
        }
        this.lbTrigger = null;
        this.mainPrev = null;
        this.mainNext = null;
        this.thumbsWrap = null;
        this.thumbsList = null;
        this.thumbEls = [];
        this.progressFill = null;
        this._countText = null;
        this._linkedVideoBtn = null;

        const useThumbNav =
            this.opts.stackedNavigationType === "thumbs" &&
            this.items.length > 1;

        // ── Stage ──
        this.stage = utils.el("div", "wcpg-stage");
        if (!useThumbNav && this.opts.stackedDotsPosition === "outside") {
            this.stage.classList.add("wcpg-dots-outside");
        }

        // ── Anchor dot rail — only when using dot navigation ──
        this.pagination = null;
        this.paginationDots = [];
        this._anchorRail = null;

        if (!useThumbNav && this.items.length > 1) {
            const _pgPos = this.opts.mainImagePaginationPosition || "left";
            this._anchorRail = utils.el(
                "div",
                `wcpg-anchor-rail wcpg-anchor-rail-${_pgPos}`,
            );
            this.pagination = utils.el(
                "div",
                `wcpg-pagination wcpg-pagination-anchor wcpg-pagination-side wcpg-pagination-${_pgPos}`,
            );
            this.items.forEach((_, i) => {
                const dot = utils.el(
                    "button",
                    "wcpg-dot" + (i === 0 ? " wcpg-dot-active" : ""),
                );
                dot.setAttribute("aria-label", `Go to image ${i + 1}`);
                dot.setAttribute("data-index", i);
                this.pagination.appendChild(dot);
                this.paginationDots.push(dot);
            });
            this._anchorRail.appendChild(this.pagination);
            this.stage.appendChild(this._anchorRail);
        }

        // ── Stacked item list ──
        this.stackedWrap = utils.el("div", "wcpg-stacked-wrap");
        this.stackedItems = [];
        this._stackedLbTriggers = [];
        this.items.forEach((item, i) => {
            const itemWrap = this._buildSingleStackedItem(item, i);
            this.stackedWrap.appendChild(itemWrap);
            this.stackedItems.push(itemWrap);
        });
        this.stage.appendChild(this.stackedWrap);

        // ── Lightbox DOM ──
        if (this.opts.lightbox && !this.constructor._lbEl) {
            this.constructor._lbEl = this._createLightboxDOM();
            document.body.appendChild(this.constructor._lbEl);
        }

        // ── Thumbnail navigation — only when using thumb navigation ──
        if (useThumbNav) {
            // Coerce top/bottom → left; those positions are unsupported in stacked layout
            if (!["left", "right"].includes(this.opts.thumbnailPosition)) {
                this.opts.thumbnailPosition = "left";
            }

            // Set CSS custom properties needed by the thumbnail system
            const s = this.wrapper.style;
            s.setProperty("--wcpg-thumb-w", this.opts.thumbnailWidth + "px");
            s.setProperty("--wcpg-thumb-h", this.opts.thumbnailHeight + "px");
            s.setProperty("--wcpg-thumb-gap", this.opts.thumbnailGap + "px");
            s.setProperty(
                "--wcpg-strip-gap",
                this.opts.thumbnailStripGap + "px",
            );
            s.setProperty(
                "--wcpg-active-color",
                this.opts.thumbnailActiveBorderColor,
            );
            s.setProperty(
                "--wcpg-active-bw",
                this.opts.thumbnailActiveBorderWidth + "px",
            );
            s.setProperty(
                "--wcpg-thumb-radius",
                this.opts.thumbnailBorderRadius + "px",
            );
            s.setProperty(
                "--wcpg-grid-cols",
                String(
                    Math.min(this.opts.thumbnailGridColumns, this.items.length),
                ),
            );

            // Sticky top offset for left/right thumb strips
            s.setProperty(
                "--wcpg-stacked-thumbs-top",
                (this.opts.stackedThumbsStickyTop ?? 40) + "px",
            );

            // Add position class so CSS targets thumb layout correctly
            this.wrapper.classList.add(
                `wcpg-thumb-${this.opts.thumbnailPosition}`,
            );

            this._buildThumbnails();

            const isSidePos = ["left", "right"].includes(
                this.opts.thumbnailPosition,
            );
            if (isSidePos && this.thumbsWrap) {
                const row = utils.el("div", "wcpg-row");
                if (this.opts.thumbnailPosition === "left") {
                    row.appendChild(this.thumbsWrap);
                    row.appendChild(this.stage);
                } else {
                    row.appendChild(this.stage);
                    row.appendChild(this.thumbsWrap);
                }
                this.wrapper.appendChild(row);
            } else {
                this.wrapper.appendChild(this.stage);
                if (this.thumbsWrap) this.wrapper.appendChild(this.thumbsWrap);
            }
        } else {
            this.wrapper.appendChild(this.stage);
        }

        this._removeSkeleton();
    },

    // ── Sticky Split layout ───────────────────────────────────────────────────

    _buildStickySplitLayout() {
        this.wrapper.classList.add("wcpg-layout-sticky-split");

        const s = this.wrapper.style;
        s.setProperty(
            "--wcpg-ss-main-w",
            this.opts.stickySplitMainWidthPercent + "%",
        );
        s.setProperty("--wcpg-ss-gap", this.opts.stickySplitGap + "px");
        s.setProperty(
            "--wcpg-ss-sticky-top",
            this.opts.stickySplitStickyTop + "px",
        );
        s.setProperty(
            "--wcpg-ss-item-gap",
            this.opts.stickySplitScrollItemGap + "px",
        );
        s.setProperty(
            "--wcpg-ss-item-radius",
            this.opts.stickySplitScrollItemBorderRadius + "px",
        );
        s.setProperty(
            "--wcpg-ss-item-aspect",
            this.opts.stickySplitScrollItemAspect === "auto"
                ? "auto"
                : this.opts.stickySplitScrollItemAspect,
        );
        s.setProperty("--wcpg-ss-item-fit", this.opts.stickySplitScrollItemFit);
        s.setProperty("--wcpg-ss-item-bg", this.opts.mainImageBackground);

        // ── Main image elements (reuse same carousel machinery) ──
        this.stage = utils.el("div", "wcpg-stage");
        this.mainWrap = utils.el("div", "wcpg-main-wrap");
        this.mainDisplay = utils.el("div", "wcpg-main-display");

        if (
            this.opts.mainImageHeightMode === "fixed" &&
            this.opts.mainImageHeight
        ) {
            this.mainDisplay.style.height = this.opts.mainImageHeight + "px";
        }

        this.mainImg = utils.el("img", "wcpg-main-img");
        this.mainImg.draggable = false;
        this.mainImg.style.objectFit = this.opts.mainImageFit;
        if (this.opts.mainImageFit === "cover") {
            this.mainDisplay.classList.add("wcpg-fit-cover");
        }

        this.placeholderImg = utils.el("img", "wcpg-placeholder-img");
        this.placeholderImg.draggable = false;
        this.placeholderImg.alt = "";
        this.placeholderImg.setAttribute("aria-hidden", "true");

        this.mainVideo = utils.el("video", "wcpg-main-video");
        this.mainVideo.controls = this.opts.videoControls;
        this.mainVideo.playsInline = true;
        this.mainVideo.loop = this.opts.videoHostedLoop;
        if (this.opts.videoHostedMuted) this.mainVideo.muted = true;
        this.mainVideo.style.display = "none";

        this.mainIframe = utils.el("iframe", "wcpg-main-iframe");
        this.mainIframe.setAttribute("frameborder", "0");
        this.mainIframe.setAttribute("allowfullscreen", "");
        this.mainIframe.setAttribute(
            "referrerpolicy",
            "strict-origin-when-cross-origin",
        );
        this.mainIframe.setAttribute(
            "allow",
            "autoplay; fullscreen; picture-in-picture; encrypted-media",
        );
        this.mainIframe.setAttribute("title", "");
        this.mainIframe.style.display = "none";

        this._linkedVideoBtn = utils.el("button", "wcpg-linked-video-btn");
        this._linkedVideoBtn.setAttribute("aria-label", "Play video");
        this._linkedVideoBtn.innerHTML = PLAY_SVG;
        this._linkedVideoBtn.style.display = "none";
        utils.on(this._linkedVideoBtn, "click", (e) => {
            e.stopPropagation();
            this._playLinkedVideo();
        });

        this.mainDisplay.appendChild(this.placeholderImg);
        this.mainDisplay.appendChild(this.mainImg);
        this.mainDisplay.appendChild(this.mainVideo);
        this.mainDisplay.appendChild(this.mainIframe);
        this.mainDisplay.appendChild(this._linkedVideoBtn);

        this.spinner = utils.el("div", "wcpg-spinner");
        this.spinner.appendChild(utils.el("div", "wcpg-spinner-inner"));

        // ── Lens / Window Cursor / Zoom Window ──
        ({ lens: this.lens, winCursor: this.winCursor, zoomWin: this.zoomWin } =
            this._buildZoomElements());
        this.mainWrap.appendChild(this.winCursor);

        this.lbTrigger = null;
        if (this.opts.lightbox && this.opts.lightboxOnClick) {
            this.lbTrigger = this._makeLbTriggerBtn();
            this.mainWrap.appendChild(this.lbTrigger);
            if (!this.opts.lightboxButtonAutoHide) {
                this.mainWrap.classList.add("wcpg-lb-always");
            }
        }

        this.mainPrev = null;
        this.mainNext = null;
        if (this.opts.mainImageArrows && this.items.length > 1) {
            this.mainPrev = utils.el(
                "button",
                "wcpg-main-arrow wcpg-main-prev",
            );
            this.mainPrev.setAttribute("aria-label", "Previous image");
            this.mainPrev.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>`;
            this.mainNext = utils.el(
                "button",
                "wcpg-main-arrow wcpg-main-next",
            );
            this.mainNext.setAttribute("aria-label", "Next image");
            this.mainNext.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>`;
            this.mainWrap.appendChild(this.mainPrev);
            this.mainWrap.appendChild(this.mainNext);
            if (!this.opts.mainImageArrowsAutoHide) {
                this.mainWrap.classList.add("wcpg-arrows-always");
            }
        }

        this.mainWrap.appendChild(this.mainDisplay);
        this.mainWrap.appendChild(this.spinner);
        this.mainWrap.appendChild(this.lens);
        this.stage.appendChild(this.mainWrap);

        this.pagination = null;
        this.paginationDots = [];
        this.progressFill = null;
        this._countText = null;
        if (this.opts.mainImagePagination && this.items.length > 1) {
            this.pagination = utils.el("div", "wcpg-pagination");
            if (this.opts.mainImagePaginationType === "progressbar") {
                this.pagination.classList.add("wcpg-pagination-progress");
                this.progressFill = utils.el("div", "wcpg-progress-fill");
                this.progressFill.style.width =
                    (1 / this.items.length) * 100 + "%";
                this.pagination.appendChild(this.progressFill);
            } else if (this.opts.mainImagePaginationType === "count") {
                this.pagination.classList.add("wcpg-pagination-count");
                const countPrev = utils.el(
                    "button",
                    "wcpg-count-nav wcpg-count-prev",
                );
                countPrev.setAttribute("aria-label", "Previous image");
                countPrev.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>`;
                this._countText = utils.el("span", "wcpg-count-text");
                this._countText.textContent = `1 / ${this.items.length}`;
                const countNext = utils.el(
                    "button",
                    "wcpg-count-nav wcpg-count-next",
                );
                countNext.setAttribute("aria-label", "Next image");
                countNext.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>`;
                this.pagination.appendChild(countPrev);
                this.pagination.appendChild(this._countText);
                this.pagination.appendChild(countNext);
            } else {
                this.items.forEach((_, i) => {
                    const dot = utils.el(
                        "button",
                        "wcpg-dot" + (i === 0 ? " wcpg-dot-active" : ""),
                    );
                    dot.setAttribute("aria-label", `Go to image ${i + 1}`);
                    dot.setAttribute("data-index", i);
                    this.pagination.appendChild(dot);
                    this.paginationDots.push(dot);
                });
            }
            if (this.opts.mainImagePaginationAutoHide) {
                this.pagination.classList.add("wcpg-pagination-autohide");
            }
            this.mainWrap.appendChild(this.pagination);
        }

        document.body.appendChild(this.zoomWin);

        // ── Scroll column items ──
        this.ssScrollWrap = utils.el("div", "wcpg-ss-wrap");
        this._ssItemEls = [];
        this.items.forEach((item, i) => {
            const itemEl = this._buildSSScrollItem(item, i);
            if (i !== 0 || this.opts.stickySplitShowMainInScroll !== false) {
                this.ssScrollWrap.appendChild(itemEl);
            }
            this._ssItemEls.push(itemEl);
        });

        const stickyCol = utils.el("div", "wcpg-ss-sticky-col");
        this.ssStickyCol = stickyCol;
        stickyCol.appendChild(this.stage);

        const scrollCol = utils.el("div", "wcpg-ss-scroll-col");
        scrollCol.appendChild(this.ssScrollWrap);

        const row = utils.el("div", "wcpg-ss-row");
        if (this.opts.stickySplitMainSide === "right") {
            row.appendChild(scrollCol);
            row.appendChild(stickyCol);
        } else {
            row.appendChild(stickyCol);
            row.appendChild(scrollCol);
        }
        this.wrapper.appendChild(row);

        // Carousel thumbnail refs nulled — not used in sticky-split desktop mode
        this.thumbsWrap = null;
        this.thumbsList = null;
        this.thumbEls = [];

        if (this.opts.lightbox && !this.constructor._lbEl) {
            this.constructor._lbEl = this._createLightboxDOM();
            document.body.appendChild(this.constructor._lbEl);
        }

        this._renderItem(0, true);

        this._removeSkeleton();
    },

    _buildSSScrollItem(item, i) {
        const isVid = item.type === "video";
        const isEmbed = item.type === "youtube" || item.type === "vimeo";
        const clickable =
            this.opts.stickySplitClickAction === "lightbox" &&
            this.opts.lightbox;

        const itemEl = utils.el(
            "div",
            "wcpg-ss-item" + (clickable ? " wcpg-ss-clickable" : ""),
        );
        itemEl.setAttribute("data-index", i);

        const playBadgeHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>`;

        if (isVid || isEmbed) {
            if (item.thumb) {
                // Thumbnail image available — render it normally
                const img = utils.el("img", "wcpg-ss-img");
                img.alt = item.caption || "";
                img.loading = i === 0 ? "eager" : "lazy";
                img.draggable = false;
                img.src = item.thumb;
                itemEl.appendChild(img);
            } else {
                // No thumbnail: let the item itself carry the aspect-ratio so the
                // flex layout engine (flex-direction:column) can resolve the height
                // directly from the item's already-known cross-axis (width).
                // A child div with aspect-ratio creates a circular dependency and
                // collapses to 0 height in many browsers.
                itemEl.classList.add("wcpg-ss-no-thumb");
            }
            const badge = utils.el("div", "wcpg-ss-play-badge");
            badge.innerHTML = playBadgeHTML;
            itemEl.appendChild(badge);
        } else {
            const img = utils.el("img", "wcpg-ss-img");
            img.alt = item.caption || "";
            img.loading = i === 0 ? "eager" : "lazy";
            img.draggable = false;
            img.src = item.src || item.thumb || "";
            itemEl.appendChild(img);

            // Image with a linked video — overlay a play badge
            if (item.linkedVideoType) {
                const badge = utils.el("div", "wcpg-ss-play-badge");
                badge.innerHTML = playBadgeHTML;
                itemEl.appendChild(badge);
            }
        }

        if (this.opts.stickySplitShowCaption && item.caption) {
            const cap = utils.el("div", "wcpg-ss-caption");
            cap.textContent = item.caption;
            itemEl.appendChild(cap);
        }

        return itemEl;
    },

    // ── Hierarchy Grid layout ─────────────────────────────────────────────────

    _buildSingleHGItem(item, i, isHero) {
        const itemWrap = utils.el(
            "div",
            "wcpg-hg-item" + (isHero ? " wcpg-hg-hero" : ""),
        );
        itemWrap.setAttribute("data-wcpg-hg-index", i);

        // Reserve the hero's height before the image loads so the layout
        // doesn't collapse between skeleton removal and image decode.
        if (isHero && item.w && item.h) {
            itemWrap.style.aspectRatio = `${item.w} / ${item.h}`;
        }

        const isVid = item.type === "video";
        const isEmbed = item.type === "youtube" || item.type === "vimeo";

        if (isEmbed) {
            const iframe = utils.el("iframe", "wcpg-hg-iframe");
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute(
                "allow",
                "autoplay; fullscreen; picture-in-picture; encrypted-media",
            );
            let embedSrc = item.embed || item.src;
            if (
                item.type === "youtube" &&
                embedSrc.indexOf("enablejsapi=") === -1
            ) {
                embedSrc +=
                    (embedSrc.indexOf("?") === -1 ? "?" : "&") +
                    "enablejsapi=1";
            }
            iframe.src = embedSrc;
            // Fit-container: fill grid cell absolutely when a fixed aspect-ratio
            // is applied to the cell (avoids empty space below a 16:9 iframe in a
            // 1:1 container), or when the user explicitly enables videoEmbedFitContainer.
            const _hgAspectFixed = this.opts.hierarchyGridItemAspect !== "auto";
            if (
                !isHero &&
                (this.opts.videoEmbedFitContainer || _hgAspectFixed)
            ) {
                iframe.classList.add("wcpg-fit");
            }
            itemWrap.appendChild(iframe);
        } else if (isVid) {
            const video = utils.el("video", "wcpg-hg-video");
            video.controls = this.opts.videoControls;
            video.playsInline = true;
            video.loop = this.opts.videoHostedLoop;
            if (this.opts.videoHostedMuted) video.muted = true;
            if (this.opts.videoHostedAutoplay) {
                video.autoplay = true;
                video.muted = true; // browsers require muted for autoplay
            }
            video.setAttribute("preload", "metadata");
            video.src = item.src;
            // Use explicit poster first, fall back to thumbnail so the cell
            // shows a preview frame instead of a black rectangle
            const _vPoster = item.poster || item.thumb || "";
            if (_vPoster) video.poster = _vPoster;
            // Fit-container: fill grid cell absolutely when a fixed aspect-ratio
            // is applied to the cell, or when the user explicitly enables videoHostedFitContainer.
            const _hgAspectFixedVid =
                this.opts.hierarchyGridItemAspect !== "auto";
            if (
                !isHero &&
                (this.opts.videoHostedFitContainer || _hgAspectFixedVid)
            ) {
                video.classList.add("wcpg-fit");
            }
            itemWrap.appendChild(video);
        } else {
            const zoomDisplay = utils.el("div", "wcpg-hg-display");
            const img = utils.el("img", "wcpg-hg-img");
            img.src = item.src;
            img.alt = item.caption || "";
            img.draggable = false;
            if (isHero) {
                img.style.objectFit = this.opts.mainImageFit;
            }

            if (item.placeholder) {
                const ph = utils.el("img", "wcpg-hg-placeholder");
                ph.src = item.placeholder;
                ph.alt = "";
                ph.draggable = false;
                ph.setAttribute("aria-hidden", "true");
                ph.style.objectFit = isHero
                    ? this.opts.mainImageFit
                    : this.opts.hierarchyGridItemFit || "cover";
                zoomDisplay.appendChild(ph);
                const clearPh = () => {
                    ph.classList.add("wcpg-hg-ph-hide");
                    setTimeout(() => ph.remove(), 400);
                };
                if (img.complete && img.naturalWidth > 0) {
                    ph.remove();
                } else {
                    img.addEventListener("load", clearPh, { once: true });
                }
            }

            zoomDisplay.appendChild(img);
            itemWrap.appendChild(zoomDisplay);

            // Linked video — reuse wcpg-stacked-lv-* elements so the
            // shared _playStackedLinkedVideo / _stopStackedLinkedVideo
            // methods work without duplication.
            if (item.linkedVideoType) {
                this._buildLinkedVideoOverlay(itemWrap, item);
            }
        }

        // Lightbox trigger: skip for hosted video items — the trigger button
        // is positioned at bottom-right and would overlay the native controls bar.
        // Embed (iframe) and image items keep the trigger as normal.
        if (this.opts.lightbox && this.opts.lightboxOnClick && !isVid) {
            const btn = this._makeLbTriggerBtn();
            itemWrap.appendChild(btn);
            if (this._hgLbTriggers) {
                this._hgLbTriggers.push({ el: btn, index: i });
            }
            if (!this.opts.lightboxButtonAutoHide) {
                itemWrap.classList.add("wcpg-lb-always");
            }
        }

        return itemWrap;
    },

    _buildTilesLayout() {
        this.wrapper.classList.add("wcpg-layout-tiles");

        // Null out carousel-specific refs
        this.mainWrap = null;
        this.mainDisplay = null;
        this.mainImg = null;
        this.mainVideo = null;
        this.mainIframe = null;
        this.placeholderImg = null;
        this.spinner = null;

        const _tilesZoomEnabled =
            this.opts.tilesZoom !== false && this.opts.zoomOnHover;

        if (_tilesZoomEnabled) {
            ({ lens: this.lens, winCursor: this.winCursor, zoomWin: this.zoomWin } =
                this._buildZoomElements());
            document.body.appendChild(this.zoomWin);
        } else {
            this.lens = null;
            this.winCursor = null;
            this.zoomWin = null;
        }

        this.lbTrigger = null;
        this.mainPrev = null;
        this.mainNext = null;
        this.thumbsWrap = null;
        this.thumbsList = null;
        this.thumbEls = [];
        this.progressFill = null;
        this._countText = null;
        this._linkedVideoBtn = null;

        // ── Tiles outer wrap ──
        this.tilesWrap = utils.el("div", "wcpg-tiles-wrap");
        this.tilesGrid = utils.el("div", "wcpg-tiles-grid");
        this.tilesItems = [];
        this._tilesLbTriggers = [];

        if (this.opts.tilesItemAspect === "auto") {
            this.tilesGrid.classList.add("wcpg-tiles-aspect-auto");
        }

        const initialCount =
            this.opts.tilesInitialCount > 0
                ? this.opts.tilesInitialCount
                : this.items.length;

        this.items.forEach((item, i) => {
            const itemWrap = this._buildSingleTilesItem(item, i);
            if (i >= initialCount) {
                itemWrap.classList.add("wcpg-tiles-hidden");
            }
            this.tilesGrid.appendChild(itemWrap);
            this.tilesItems.push(itemWrap);
        });

        this.tilesWrap.appendChild(this.tilesGrid);

        // ── Show More / Show Less button ──
        this._tilesExpanded = false;
        this._tilesShowMoreWrap = null;
        this._tilesShowMoreBtn = null;

        const hasHidden = this.items.length > initialCount;
        if (this.opts.tilesShowMoreEnabled !== false && hasHidden) {
            this._tilesShowMoreWrap = utils.el(
                "div",
                "wcpg-tiles-show-more-wrap",
            );
            this._tilesShowMoreBtn = utils.el(
                "button",
                "wcpg-tiles-show-more-btn",
            );
            this._tilesShowMoreBtn.type = "button";
            this._updateTilesShowMoreBtn();
            this._tilesShowMoreWrap.appendChild(this._tilesShowMoreBtn);
            this.tilesWrap.appendChild(this._tilesShowMoreWrap);
        }

        // ── Lightbox DOM ──
        if (this.opts.lightbox && !this.constructor._lbEl) {
            this.constructor._lbEl = this._createLightboxDOM();
            document.body.appendChild(this.constructor._lbEl);
        }

        this.wrapper.appendChild(this.tilesWrap);
        this._removeSkeleton();
    },

    _updateTilesShowMoreBtn() {
        if (!this._tilesShowMoreBtn) return;
        const text = this._tilesExpanded
            ? this.opts.tilesShowLessText || "Show Less"
            : this.opts.tilesShowMoreText || "Show More";
        const arrow = this._tilesExpanded
            ? `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="18 15 12 9 6 15"/></svg>`
            : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>`;
        this._tilesShowMoreBtn.innerHTML = `<span>${text}</span>${arrow}`;
    },

    _buildSingleTilesItem(item, i) {
        const itemWrap = utils.el("div", "wcpg-tiles-item");
        itemWrap.setAttribute("data-wcpg-tiles-index", i);

        const isVid = item.type === "video";
        const isEmbed = item.type === "youtube" || item.type === "vimeo";

        if (isEmbed) {
            const iframe = utils.el("iframe", "wcpg-tiles-iframe");
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute(
                "allow",
                "autoplay; fullscreen; picture-in-picture; encrypted-media",
            );
            let embedSrc = item.embed || item.src;
            if (
                item.type === "youtube" &&
                embedSrc.indexOf("enablejsapi=") === -1
            ) {
                embedSrc +=
                    (embedSrc.indexOf("?") === -1 ? "?" : "&") +
                    "enablejsapi=1";
            }
            iframe.src = embedSrc;
            if (
                this.opts.videoEmbedFitContainer ||
                this.opts.tilesItemAspect !== "auto"
            ) {
                iframe.classList.add("wcpg-fit");
            }
            itemWrap.appendChild(iframe);
        } else if (isVid) {
            const video = utils.el("video", "wcpg-tiles-video");
            video.controls = this.opts.videoControls;
            video.playsInline = true;
            video.loop = this.opts.videoHostedLoop;
            if (this.opts.videoHostedMuted) video.muted = true;
            if (this.opts.videoHostedAutoplay) {
                video.autoplay = true;
                video.muted = true;
            }
            video.setAttribute("preload", "metadata");
            video.src = item.src;
            const _vPoster = item.poster || item.thumb || "";
            if (_vPoster) video.poster = _vPoster;
            if (
                this.opts.videoHostedFitContainer ||
                this.opts.tilesItemAspect !== "auto"
            ) {
                video.classList.add("wcpg-fit");
            }
            itemWrap.appendChild(video);
        } else {
            const zoomDisplay = utils.el("div", "wcpg-tiles-display");
            const img = utils.el("img", "wcpg-tiles-img");
            img.src = item.src;
            img.alt = item.caption || "";
            img.draggable = false;

            if (item.placeholder) {
                const ph = utils.el("img", "wcpg-tiles-placeholder");
                ph.src = item.placeholder;
                ph.alt = "";
                ph.draggable = false;
                ph.setAttribute("aria-hidden", "true");
                zoomDisplay.appendChild(ph);
                const clearPh = () => {
                    ph.classList.add("wcpg-tiles-ph-hide");
                    setTimeout(() => ph.remove(), 400);
                };
                if (img.complete && img.naturalWidth > 0) {
                    ph.remove();
                } else {
                    img.addEventListener("load", clearPh, { once: true });
                }
            }

            zoomDisplay.appendChild(img);
            itemWrap.appendChild(zoomDisplay);
        }

        // Lightbox trigger
        if (this.opts.lightbox && this.opts.lightboxOnClick && !isVid) {
            const btn = this._makeLbTriggerBtn();
            itemWrap.appendChild(btn);
            if (this._tilesLbTriggers) {
                this._tilesLbTriggers.push({ el: btn, index: i });
            }
            if (!this.opts.lightboxButtonAutoHide) {
                itemWrap.classList.add("wcpg-lb-always");
            }
        }

        return itemWrap;
    },

    _buildHierarchyGridLayout() {
        this.wrapper.classList.add("wcpg-layout-hierarchy-grid");

        // Null out carousel-specific refs so _destroy() guards work correctly
        this.mainWrap = null;
        this.mainDisplay = null;
        this.mainImg = null;
        this.mainVideo = null;
        this.mainIframe = null;
        this.placeholderImg = null;
        this.spinner = null;

        const _hgZoomEnabled =
            this.opts.hierarchyGridZoom !== false && this.opts.zoomOnHover;

        if (_hgZoomEnabled) {
            ({ lens: this.lens, winCursor: this.winCursor, zoomWin: this.zoomWin } =
                this._buildZoomElements());
            document.body.appendChild(this.zoomWin);
        } else {
            this.lens = null;
            this.winCursor = null;
            this.zoomWin = null;
        }

        this.lbTrigger = null;
        this.mainPrev = null;
        this.mainNext = null;
        this.thumbsWrap = null;
        this.thumbsList = null;
        this.thumbEls = [];
        this.progressFill = null;
        this._countText = null;
        this._linkedVideoBtn = null;

        // ── HG wrap — hero + grid ──
        this.hgWrap = utils.el("div", "wcpg-hg-wrap");
        this.hgItems = [];
        this._hgLbTriggers = [];

        if (this.items.length > 0) {
            const heroWrap = this._buildSingleHGItem(this.items[0], 0, true);
            this.hgWrap.appendChild(heroWrap);
            this.hgItems.push(heroWrap);
        }

        if (this.items.length > 1) {
            const grid = utils.el("div", "wcpg-hg-grid");
            if (this.opts.hierarchyGridItemAspect === "auto") {
                grid.classList.add("wcpg-hg-aspect-auto");
            }
            for (let i = 1; i < this.items.length; i++) {
                const itemWrap = this._buildSingleHGItem(
                    this.items[i],
                    i,
                    false,
                );
                grid.appendChild(itemWrap);
                this.hgItems.push(itemWrap);
            }
            this.hgWrap.appendChild(grid);
        }

        // ── Lightbox DOM ──
        if (this.opts.lightbox && !this.constructor._lbEl) {
            this.constructor._lbEl = this._createLightboxDOM();
            document.body.appendChild(this.constructor._lbEl);
        }

        this.wrapper.appendChild(this.hgWrap);

        this._removeSkeleton();
    },

    // ── Shared element builders ───────────────────────────────────────────────

    // Creates the lens, window-cursor overlay, and zoom window from current
    // options. Caller appends winCursor/lens to the container and zoomWin to
    // document.body at the appropriate points in the layout sequence.
    _buildZoomElements() {
        const o = this.opts;
        const lens = utils.el("div", "wcpg-lens");
        lens.style.width = o.lensSize + "px";
        lens.style.height = o.lensSize + "px";
        lens.style.borderRadius =
            o.lensShape === "circle" ? "50%" : o.thumbnailBorderRadius + "px";
        lens.style.borderColor = o.lensBorderColor;
        lens.style.borderWidth = o.lensBorderWidth + "px";
        lens.style.backgroundRepeat = "no-repeat";

        // NOTE: do NOT set style.opacity here — it would permanently override
        // the CSS class-based opacity transition (opacity-0 → opacity-var).
        const winCursor = utils.el("div", "wcpg-win-cursor");
        winCursor.style.borderColor = o.zoomWindowCursorBorderColor;
        winCursor.style.borderWidth = o.zoomWindowCursorBorderWidth + "px";
        winCursor.style.borderRadius = o.zoomWindowCursorBorderRadius + "px";
        winCursor.style.background = o.zoomWindowCursorBg;

        const zoomWin = utils.el("div", "wcpg-zoom-window");
        zoomWin.style.width = o.zoomWindowWidth + "px";
        zoomWin.style.height = o.zoomWindowHeight + "px";
        zoomWin.style.borderRadius = o.zoomWindowBorderRadius + "px";
        zoomWin.style.setProperty("--wcpg-zwin-bw", o.zoomWindowBorderWidth + "px");
        zoomWin.style.setProperty("--wcpg-zwin-bc", o.zoomWindowBorderColor);
        zoomWin.style.boxShadow = o.zoomWindowShadow
            ? "0 8px 40px rgba(0,0,0,0.22)"
            : "none";
        zoomWin.style.backgroundRepeat = "no-repeat";
        zoomWin.style.transition = o.zoomWindowFadeEasing
            ? `opacity ${utils.clamp(o.zoomWindowFadeEasingAmount, 0, 2000)}ms ease`
            : "none";

        return { lens, winCursor, zoomWin };
    },

    // Creates the lightbox expand-icon trigger button for the current options.
    _makeLbTriggerBtn() {
        const btn = utils.el(
            "button",
            `wcpg-lb-trigger wcpg-lb-pos-${this.opts.lightboxButtonPosition}`,
        );
        btn.setAttribute("aria-label", "Open fullscreen");
        btn.innerHTML = LB_EXPAND_SVG;
        return btn;
    },

    // Appends linked-video overlay elements (play button, embed iframe or hosted
    // video, and close button) to itemWrap. Shared by stacked and hierarchy-grid
    // item builders which use identical DOM for per-image linked videos.
    _buildLinkedVideoOverlay(itemWrap, item) {
        const _isLvEmbed =
            item.linkedVideoType === "youtube" || item.linkedVideoType === "vimeo";
        const _lvPlay = utils.el("button", "wcpg-linked-video-btn");
        _lvPlay.setAttribute("aria-label", "Play video");
        _lvPlay.innerHTML = PLAY_SVG;
        itemWrap.appendChild(_lvPlay);
        if (_isLvEmbed) {
            const _lvIframe = utils.el("iframe", "wcpg-stacked-lv-iframe");
            _lvIframe.setAttribute("frameborder", "0");
            _lvIframe.setAttribute("allowfullscreen", "");
            _lvIframe.setAttribute(
                "allow",
                "autoplay; fullscreen; picture-in-picture; encrypted-media",
            );
            let _lvSrc = item.linkedVideoEmbed || "";
            if (
                item.linkedVideoType === "youtube" &&
                _lvSrc.indexOf("enablejsapi=") === -1
            ) {
                _lvSrc +=
                    (_lvSrc.indexOf("?") === -1 ? "?" : "&") + "enablejsapi=1";
            }
            _lvIframe.setAttribute("data-wcpg-lv-src", _lvSrc);
            itemWrap.appendChild(_lvIframe);
        } else {
            const _lvVideo = utils.el("video", "wcpg-stacked-lv-video");
            _lvVideo.controls = this.opts.videoControls;
            _lvVideo.playsInline = true;
            _lvVideo.loop = this.opts.videoHostedLoop;
            if (this.opts.videoHostedMuted) _lvVideo.muted = true;
            itemWrap.appendChild(_lvVideo);
        }
        const _lvClose = utils.el("button", "wcpg-stacked-linked-close");
        _lvClose.setAttribute("aria-label", "Back to image");
        _lvClose.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
        itemWrap.appendChild(_lvClose);
    },

    // Removes server-side loading skeleton elements from the wrapper.
    _removeSkeleton() {
        this.wrapper
            .querySelectorAll("[data-wcpg-skeleton]")
            .forEach((sk) => sk.remove());
    },
};

export default domMethods;
